import styled from 'styled-components';
import { Form } from 'react-bootstrap';
import { spacing } from '../tokens';

// FormGroup — wrap Form.Group với spacing-bottom thống nhất theo
// tokens. Dùng khi tự compose Label + Form.Control thay vì TextInput.
const FormGroup = styled(Form.Group)`
  margin-bottom: ${spacing[4]};
`;

export default FormGroup;
